import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import dayGridPlugin from "@fullcalendar/daygrid";

import { AuthService } from "./services/auth.service";

@Component({
    selector: "app",
    templateUrl: "./app.component.html",
    providers: [],
    standalone: false
})
export class AppComponent implements OnInit{

    calendarPlugins = [dayGridPlugin];

    // Inject Auth Service on app start
    constructor(
        public readonly authService: AuthService,
        @Inject(PLATFORM_ID) public readonly platformId: Object,
    ) {
    }

    // OnInit - prepare app and oauth service
    ngOnInit() {

    }
}
